import { useNavigate, useLocation } from 'react-router-dom';
import '../App.css';
import BlossomToggle from './Blossom/BlossomToggle';

const Naving = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const links = [
    { label: 'Experience', path: '/Experience' },
    { label: 'Projects', path: '/Projects' },
    { label: 'What I Do', path: '/WhatIDo' },
  ];

  // Petals only spawn on the projects/home page — surfacing the toggle on
  // pages where it has no effect just confuses people.
  const lower = location.pathname.toLowerCase();
  const showBlossomToggle = lower === '/' || lower === '/projects';

  return (
    <nav className="site-nav">
      <button
        className="nav-brand"
        onClick={() => {
          const p = location.pathname.toLowerCase();
          if (p === '/' || p === '/projects') return;
          navigate('/');
        }}
      >
        <span className="brand-name">Guy Boxall</span>
        <span className="brand-role">Interactive Creative Technologist</span>
      </button>
      <div className="nav-links">
        {links.map(l => {
          const isProjects = l.label === 'Projects';
          const active = isProjects
            ? (location.pathname === '/' || location.pathname === '/Projects')
            : location.pathname === l.path;
          return (
            <button
              key={l.path}
              onClick={() => navigate(l.path)}
              className={"nav-link" + (active ? ' active' : '')}
            >
              <span>{l.label}</span>
            </button>
          );
        })}
        {showBlossomToggle && <BlossomToggle />}
      </div>
    </nav>
  );
};

export default Naving;